import axios from 'axios'
import { BACKEND_URL, TIMEOUT } from '../services/backendURL'
import { showErrorToast } from '../helpers/toast'

const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem('authUser')
    if (raw) {
      try {
        const authUser = JSON.parse(raw)
        if (authUser && authUser.key) {
          config.headers.Authorization = `Token ${authUser.key}`
        }
      } catch (e) {
        // invalid JSON in localStorage
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      showErrorToast('Nuk ka lidhje me serverin.')
      return Promise.reject(error)
    }

    const { status, data } = error.response

    if (status === 401 || status === 403) {
      localStorage.clear()
      window.location.href = '/login'
      return Promise.reject(error)
    }

    if (data && data.Error) {
      showErrorToast(data.Error)
    } else if (data && data.detail) {
      showErrorToast(data.detail)
    } else if (status >= 500) {
      showErrorToast('Gabim ne server. Provoni perseri.')
    }

    return Promise.reject(error)
  }
)

export default api
